<template>
  <div class="container">
    <p v-if="inProgress">
      Zahlungsmethode wird gespeichert <b-spinner />
    </p>
    <p v-if="success">Die Zahlungsmethode wurde erfolgreich gespeichert.</p>
  </div>
</template>

<script>
import buyer from "@/api/buyer";

export default {
  data: () => ({
    inProgress: true,
    success: false
  }),
  computed: {
    sessionId () {
      return this.$route.query.session_id
}
  },
  created () {
    console.log(this.$route.query)
  },
  async mounted() {
    try {
      await buyer.savePaymentMethod(this.sessionId)
      this.success = true
    } catch (error) {
      const message = error.response.data
      this.$bvToast.toast(message, {variant: 'danger', title: "Error"})
    } finally {
      this.inProgress = false
    }
  }
}
</script>